import React, { useState, useEffect } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { toast } from "react-toastify";
import { PhoneInput } from "react-international-phone";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import Select from "react-select";
import { ImageUpload } from "../../../../components/imageUpload";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const EditCompanyMaster = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Company Master Edit"));
  }, []);

  const [typeOptions, setTypeOptions] = useState([]);
  const [dateFormat, setDateFormat] = useState([]);
  const [timeFormat, setTimeFormat] = useState([]);
  const [timeZone, setTimeZone] = useState([]);
  const [headOffice, setHeadOffice] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [fileName, setFileName] = useState("");
  const [profilePic, setProfilePic] = useState("");
  // alternate logo
  const [errors, setErrors] = useState({});
  const [logofileName, setLogofileName] = useState("");
  const [logoprofilePic, setLogoProfilePic] = useState("");
  const [Area, setArea] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialData = {
    ID: "",
    Code: "",
    Name: "",
    Description: "",
    Logo: "",
    AltenateLogo: "",
    StartDate: "",
    ActiveFYFromDate: "",
    ActiveFYToDate: "",
    HRCalendarStartDate: "",
    CloseDate: "",
    HomeCurrencyID: "",
    DateFormat: "",
    TimeFormat: "",
    TimeZone: "",
    HOBranchID: "",
    AreaID: "",
    MobileNo1: "",
    PrintAddress: "",
    MobileNo2: "",
    PhoneNo1: "",
    IsClosed: "",
    PhoneNo2: "",
    FaxNo: "",
    Email: "",
    Email_account: "",
    Email_sales: "",
    Email_hr: "",
    CityID: "",
    // City: '',
    // State: '',
    StateID: "",
    // Country: '',
    CountryID: "",
    ZipCode: "",
    Website: "",
    DayCloseByBranchTime: 0,
    PrintBranchDetails: 0,
  };
  const [formData, setFormData] = useState(initialData);
  console.log("formData", formData);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchCompanyMasterEdit(id);
    }
  }, []);

  const fetchCompanyMasterEdit = async (id) => {
    const response = await GetServiceCaller(`${API_URL}company/${id}`);
    if (response.status === 200) {
      const fetchData = response?.data?.data?.header;
      const formDataEdit = {
        ID: fetchData?.ID,
        Code: fetchData?.Code,
        Name: fetchData?.Name,
        Description: fetchData?.Description,
        StartDate: fetchData?.StartDate
          ? moment(fetchData?.StartDate).format("DD-MMM-YYYY")
          : "",
        ActiveFYFromDate: fetchData?.ActiveFYFromDate
          ? moment(fetchData?.ActiveFYFromDate).format("DD-MMM-YYYY")
          : "",
        ActiveFYToDate: fetchData?.ActiveFYToDate
          ? moment(fetchData?.ActiveFYToDate).format("DD-MMM-YYYY")
          : "",
        HRCalendarStartDate: fetchData?.HRCalendarStartDate
          ? moment(fetchData?.HRCalendarStartDate).format("DD-MMM-YYYY")
          : "",
        CloseDate: fetchData?.CloseDate
          ? moment(fetchData?.CloseDate).format("DD-MMM-YYYY")
          : "",
        HomeCurrencyID: fetchData?.HomeCurrencyID,
        DateFormat: fetchData?.DateFormat,
        TimeFormat: fetchData?.TimeFormat,
        TimeZone: fetchData?.TimeZone,
        HOBranchID: fetchData?.HOBranchID,
        IsClosed: fetchData?.IsClosed,
        PrintAddress: fetchData?.PrintAddress,
        MobileNo1: fetchData?.MobileNo1,
        MobileNo2: fetchData?.MobileNo2,
        PhoneNo1: fetchData?.PhoneNo1,
        PhoneNo2: fetchData?.PhoneNo2,
      };
      setFormData(formDataEdit);
      setPageLoading(false);
    } else {
      console.error(
        "Failed to Company Master. Server responded with status:",
        response.status
      );
    }
  };

  const handleChange = async (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelect = (selectedOption, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: {
        label: selectedOption.label,
        value: selectedOption.value,
      },
    }));
  };

  const fetchTypeOptions = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-company-master-dropdown`
      );
      const currencyType = response?.data?.data?.currencies;
      console.log("currencyType", currencyType);

      const options = currencyType.map((currency) => ({
        value: currency.ID,
        label: currency.Name,
      }));
      setTypeOptions(options);

      // date format
      const dateformats = response?.data?.data?.dateFormat;
      const dateoptions = dateformats.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setDateFormat(dateoptions);

      // time format
      const timeformats = response?.data?.data?.timeFormat;
      const timeoptions = timeformats.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setTimeFormat(timeoptions);

      // time zone
      const timeZones = response?.data?.data?.timezone;
      const timezoneoptions = timeZones.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setTimeZone(timezoneoptions);

      // head office
      const office = response?.data?.data?.branch;
      const officeoption = office.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setHeadOffice(officeoption);

      // area details
      const area = response?.data?.data?.area;
      const areaoption = area.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setArea(areaoption);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };
  useEffect(() => {
    fetchTypeOptions();
  }, []);

  const handleFile = (file) => {
    const fileType = file.type;
    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setErrorMessage("Only PNG and JPEG formats are allowed.");
      return;
    }
    setErrorMessage("");
    setFileName(file.name);

    setFormData((prevState) => {
      const updatedFormData = {
        ...prevState,
        Logo: file,
      };
      return updatedFormData;
    });

    const previewUrl = URL.createObjectURL(file);
    setProfilePic(previewUrl);
  };

  const handleLogo = (files) => {
    console.log("check file logo", files);
    const fileType = files.type;
    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setErrorMessage("Only PNG and JPEG formats are allowed.");
      return;
    }
    setErrorMessage("");
    setLogofileName(files.name);

    // Creating a temporary object to ensure the latest state is used
    const updatedFormData = {
      ...formData,
      AltenateLogo: files,
    };

    setFormData(updatedFormData); // Updating state
    console.log("Updated formData:", updatedFormData); // Logging updated data

    const previewUrl = URL.createObjectURL(files);
    setLogoProfilePic(previewUrl);
  };

  const handleSelectChange = (selectedOption) => {
    // Define the payload to send to the API
    const payload = {
      area_id: selectedOption.value,
    };

    // Make the POST request
    PostServiceCaller(`${API_URL}fetch-area-details`, payload, "post")
      .then((response) => {
        console.log("Data sent successfully:", response.data);
        const data = response?.data?.data;
        setFormData({
          ...formData,
          CityID: { label: data?.City, value: data?.CityID },
          CountryID: { label: data?.Country, value: data?.CountryID },
          StateID: { label: data?.state, value: data?.StateID },
          AreaID: {
            label: selectedOption?.label,
            value: selectedOption?.value,
          },
          ZipCode: data?.ZipCode,
        });
      })
      .catch((error) => {
        console.error("There was an error sending the data:", error);
      });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.Description)
      newErrors.Description = "Description is required";
    if (!formData.MobileNo1) {
      newErrors.MobileNo1 = "Mobile number is required";
    } else if (formData.MobileNo1.length !== 10) {
      newErrors.MobileNo1 = "Mobile number must be in 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const updatedFormData = {
      ...formData,
      DayCloseByBranchTime: 0,
      PrintBranchDetails: 0,
    };

    console.log("Updated formData Inside the submit", updatedFormData);

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}company/update/${updatedFormData.ID}`,
        updatedFormData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => {
          window.location.href = "/company-master";
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };



  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container" id="form-input-section">
          <form onSubmit={handleSubmit} id="formOne" className="rounded bg-white">
            <div className="row p-2">
              <div className="col-md-12">
                <div className="row">
                  <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        style={{ color: "#2F2E4B" }}
                        id="assetCategory-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#assetCategory"
                        type="button"
                        role="tab"
                        aria-controls="assetCategory"
                        aria-selected="true"
                      >
                        General Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        style={{ color: "#2F2E4B" }}
                        id="brandDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#brandDetails"
                        type="button"
                        role="tab"
                        aria-controls="brandDetails"
                        aria-selected="false"
                      >
                        Company Financials
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        style={{ color: "#2F2E4B" }}
                        id="addressDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#addressDetails"
                        type="button"
                        role="tab"
                        aria-controls="addressDetails"
                        aria-selected="false"
                      >
                        Address & Contact Details
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    {/** Main Form Code start */}
                    <div
                      className="tab-pane fade show active"
                      id="assetCategory"
                      role="tabpanel"
                      aria-labelledby="assetCategory-tab"
                    >
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Code</strong>
                            </label>
                            <input
                              type="text"
                              name="Code"
                              value={formData.Code}
                              placeholder="Code"
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Name</strong>
                            </label>
                            <input
                              type="text"
                              name="Name"
                              value={formData.Name}
                              onChange={(e) => handleChange(e)}
                              placeholder="Name"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Description</strong>
                            </label>
                            <textarea
                              type="text"
                              value={formData.Description}
                              onChange={(e) => handleChange(e)}
                              placeholder="Description"
                              className="form-control"
                              id="Description"
                              name="Description"
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Logo</strong>
                            </label>
                            <div>
                              <div>
                                <img
                                  id="profilePic"
                                  className="company-logo mb-2"
                                  src={
                                    profilePic ||
                                    "https://via.placeholder.com/150"
                                  }
                                  alt="Profile Pic"
                                />
                              </div>
                              <div>
                                <ImageUpload
                                  handleFile={handleFile}
                                  buttonName="Select Logo"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Alternate Logo</strong>
                            </label>
                            <div>
                              <div>
                                <img
                                  id="logoprofilePic"
                                  className="company-logo mb-2"
                                  src={
                                    logoprofilePic ||
                                    "https://via.placeholder.com/150"
                                  }
                                  alt="Profile Pic"
                                />
                              </div>
                              <div>
                                <ImageUpload
                                  handleFile={handleLogo}
                                  buttonName="Select Logo"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show p-2"
                      id="brandDetails"
                      role="tabpanel"
                      aria-labelledby="brandDetails-tab"
                    >
                      <div className="row">
                        <div className="col-md-2">
                          <div class="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Start Date</strong>
                            </label>
                            <CustomDatePicker
                              handleChange={(date) => handleChange(date)}
                              value={formData.StartDate}
                              name="StartDate"
                              id="StartDate"
                              className="form-control"
                              placeholderText="Start Date"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-2">
                              <strong>FY From Date</strong>
                            </label>
                            <CustomDatePicker
                              name="ActiveFYFromDate"
                              handleChange={(date) => handleChange(date)}
                              className="form-control"
                              value={formData.ActiveFYFromDate}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div class="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>FY To Date</strong>
                            </label>
                            <CustomDatePicker
                              name="ActiveFYToDate"
                              handleChange={(date) => handleChange(date)}
                              value={formData.ActiveFYToDate}
                              placeholderText="To Date"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Calendar Start Date</strong>
                            </label>
                            <CustomDatePicker
                              name="HRCalendarStartDate"
                              handleChange={(date) => handleChange(date)}
                              value={formData.HRCalendarStartDate}
                              placeholderText="Start Date"
                              className="form-control"
                            />
                            <div>
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                name="IsClosed"
                                id="flexSwitchCheckChecked"
                                checked={formData.IsClosed === 1}
                                onChange={(e) => handleChange(e)}
                              />
                              <label className="col-form-label mt-0">
                                <strong>Closed</strong>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Close Date</strong>
                            </label>
                            <CustomDatePicker
                              name="CloseDate"
                              handleChange={(date) => handleChange(date)}
                              value={formData.CloseDate}
                              placeholderText="To Date"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Home Currency</strong>
                            </label>
                            <Select
                              value={typeOptions?.find(
                                (o) => o.value === formData?.HomeCurrencyID
                              )}
                              options={typeOptions}
                              name="HomeCurrencyID"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Date Format</strong>
                            </label>
                            <Select
                              value={dateFormat?.find(
                                (o) => o.value === formData?.DateFormat
                              )}
                              options={dateFormat}
                              name="DateFormat"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Time Format</strong>
                            </label>
                            <Select
                              value={timeFormat?.find(
                                (o) => o.value === formData?.TimeFormat
                              )}
                              options={timeFormat}
                              name="TimeFormat"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Time Zone</strong>
                            </label>
                            <Select
                              value={timeZone?.find(
                                (o) => o.value === formData?.TimeZone
                              )}
                              options={timeZone}
                              name="TimeZone"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-3">
                              <strong>Head Office</strong>
                            </label>
                            <Select
                              value={headOffice?.find(
                                (o) => o.value === formData?.HOBranchID
                              )}
                              options={headOffice}
                              name="HOBranchID"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade show p-2"
                      id="addressDetails"
                      role="tabpanel"
                      aria-labelledby="addressDetails-tab"
                    >
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Print Address</strong>
                            </label>
                            <input
                              type="text"
                              name="PrintAddress"
                              value={formData.PrintAddress}
                              onChange={(e) => handleChange(e)}
                              className="form-control"
                              placeholder="Address"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div>
                            <label className="col-form-label lbl me-2">
                              <strong>Area</strong>
                            </label>
                            <Select
                              options={Area}
                              onChange={handleSelectChange}
                              value={formData.AreaID}
                              name="AreaID"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>City</strong>
                            </label>
                            <input
                              type="text"
                              name="CityID"
                              onChange={(e) => handleChange(e)}
                              className="form-control"
                              placeholder="City"
                              value={formData?.CityID?.label || ""}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>State</strong>
                            </label>
                            <input
                              type="text"
                              name="StateID"
                              className="form-control"
                              placeholder="State"
                              value={formData?.StateID?.label || ""}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Country</strong>
                            </label>
                            <input
                              type="text"
                              name="CountryID"
                              className="form-control"
                              placeholder="Country"
                              onChange={(e) => handleChange(e)}
                              value={formData?.CountryID?.label || ""}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Zip Code</strong>
                            </label>
                            <input
                              type="text"
                              name="ZipCode"
                              className="form-control"
                              placeholder="Zip Code"
                              value={formData?.ZipCode}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Contact No</strong>
                            </label>
                        
                            <input

                              className="form-control"
                              name="MobileNo1"
                              value={formData.MobileNo1 || ""}
                              // onChange={(phone) =>
                              //   setFormData({
                              //     ...formData,
                              //     MobileNo1:
                              //       phone && phone.length > 4 ? phone : "",
                              //   })
                              // }
                              onChange={(e) => handleChange(e)}

                              placeholder="Contact No"
                            />
                            {errors.MobileNo1 && (
                              <span className="text-danger">
                                {errors.MobileNo1}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-2">
                              <strong>Alternate Contact No</strong>
                            </label>
                            <input
                              className="form-control"
                              name="MobileNo2"
                              value={formData.MobileNo2 || ""}
                              onChange={(e) => handleChange(e)}

                              placeholder="Alternate Contact No"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Phone No</strong>
                            </label>
                            <input
                              className="form-control"
                              name="PhoneNo1"
                              value={formData.PhoneNo1 || ""}

                              onChange={(e) => handleChange(e)}

                              placeholder="Phone No"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Alternate Phone No</strong>
                            </label>
                            <input
                              // defaultCountry="in"
                              className="form-control"
                              name="PhoneNo2"
                              value={formData.PhoneNo2 || ""}
                              // onChange={(phone) =>
                              //   setFormData({
                              //     ...formData,
                              //     PhoneNo2:
                              //       phone && phone.length > 4 ? phone : "",
                              //   })
                              // }
                              onChange={(e) => handleChange(e)}

                              placeholder="Alternate Phone No"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Fax No:</strong>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="FaxNo"
                              value={formData.FaxNo}
                              onChange={(e) => handleChange(e)}
                              name="FaxNo"
                              placeholder="Fax no"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Email (Operation)</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="Email"
                              name="Email"
                              value={formData.Email}
                              onChange={(e) => handleChange(e)}
                              placeholder="Email(Operation)"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Email (Account)</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              value={formData.Email_account}
                              onChange={(e) => handleChange(e)}
                              id="Email_account"
                              name="Email_account"
                              placeholder="Email(Account)"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Email (Sales)</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="Email_sales"
                              value={formData.Email_sales}
                              onChange={(e) => handleChange(e)}
                              name="Email_sales"
                              placeholder="Email(Sales)"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Email (HR)</strong>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="Email_hr"
                              name="Email_hr"
                              value={formData.Email_hr}
                              onChange={(e) => handleChange(e)}
                              placeholder="Email(HR)"
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="form-group">
                            <label className="col-form-label lbl me-3">
                              <strong>Website</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="Website"
                              name="Website"
                              value={formData.Website}
                              onChange={(e) => handleChange(e)}
                              placeholder="Website"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="d-flex me-2">
                <div>
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => (window.location.href = "/company-master")}
                  >
                    Cancel
                  </button>
                </div>
                <div>
                  <button type="submit" className="custom-btn">
                    {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default EditCompanyMaster;
